module.exports = __webpack_public_path__ + "static/img/51.e992efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/51.png
// module id = TqLw
// module chunks = 0